const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
	init_fetching: true,
	update_fetching: false,
	tax_free_amount: undefined,
	tax_percent: undefined,
	amount: undefined,
	net_amount: undefined,
	tax: undefined,
};

const setDataInternal = (state, payload) => {
	state.tax_free_amount = payload["tax_free_amount"];
	state.tax_percent = payload["tax_percent"];
	state.amount = payload["amount"];
	state.net_amount = payload["net_amount"];
	state.tax = payload["tax"];
};

const taxSlice = createSlice({
	name: "tax_slice",
	initialState,
	reducers: {
		initFetch: (state) => {
			if (!state.init_fetching) state.init_fetching = true;
		},
		initResponse: (state, action) => {
			state.init_fetching = false;
			setDataInternal(state, action.payload);
		},
		initError: (state) => {
			state.init_fetching = false;
		},
		updateFetch: (state) => {
			state.update_fetching = true;
		},
		updateResponse: (state, action) => {
			state.update_fetching = false;
			setDataInternal(state, action.payload);
		},
		updateError: (state) => {
			state.update_fetching = false;
		},
		drop: () => initialState,
	},
});

export const taxActions = taxSlice.actions;
export const taxReducer = taxSlice.reducer;
export const taxSelect = {
	init_fetching: (state) => state.tax.init_fetching,
	update_fetching: (state) => state.tax.update_fetching,
	tax_free_amount: (state) => state.tax.tax_free_amount,
	tax_percent: (state) => state.tax.tax_percent,
	amount: (state) => state.tax.amount,
	net_amount: (state) => state.tax.net_amount,
	tax: (state) => state.tax.tax,
	is_reached_limit: (state) => state.tax.amount >= state.tax.tax_free_amount,
	all: (state) => {
		return {
			init_fetching: state.tax.init_fetching,
			update_fetching: state.tax.update_fetching,
			tax_free_amount: state.tax.tax_free_amount,
			tax_percent: state.tax.tax_percent,
			amount: state.tax.amount,
			net_amount: state.tax.net_amount,
			tax: state.tax.tax,
		};
	},
};
